import {Editor, Transforms} from 'slate';

function onArrowDownBeforeCollapsedContent (editor, event, selectionMeta) {
  const {
    selectionStart,
    selectionStartElement,
    selectionStartElementPath,
  } = selectionMeta;

  if (
    event.key !== 'ArrowDown' ||
    !selectionStart ||
    ![
      'process-title',
      'help-block-title',
      'process-step-title',
    ].includes(selectionStartElement.type)
  ) {
    return false;
  }

  const [parentElement] = Editor.parent(editor, selectionStartElementPath);
  if (parentElement.open) {
    return false;
  }

  event.preventDefault();

  const nextPoint = Editor.after(editor, selectionStartElementPath.slice(0, -1));
  const endOfNextElement = Editor.end(editor, nextPoint.path);

  requestAnimationFrame(() =>
    Transforms.select(
      editor,
      {
        path: nextPoint.path,
        offset: Math.min(endOfNextElement.offset, selectionStart.offset),
      }
    ));

  return true;
}

export default onArrowDownBeforeCollapsedContent;
